export default "__VITE_ASSET__DBidpl1q__"